
export default function ProcessSection() {
  const steps = [
    {
      number: 1,
      title: "現状診断",
      description: "段取り・不良・工具費ヒアリング",
      duration: "1週間"
    },
    {
      number: 2,
      title: "デモ",
      description: "実工具を使用して測定可否、くり返し精度等を確認。→ 実ワークで一発良品を確認",
      duration: "1-2日"
    },
    {
      number: 3,
      title: "設置・接続・教育",
      description: "機器設置、NC接続、オペレーター教育",
      duration: "1-2週間※装置の納期が2－5か月"
    },
    {
      number: 4,
      title: "本稼働",
      description: "KPI：段取り時間・不良率・稼働率",
      duration: "1ヶ月"
    },
    {
      number: 5,
      title: "拡張",
      description: "TMS連携／無人化セル／他ライン水平展開",
      duration: "継続"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            導入〜運用の流れ
          </h2>
          <p className="text-xl text-gray-600">最短3〜7ヶ月</p>
        </div>
        
        <div className="relative">
          {/* タイムライン線 */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-yellow-400 hidden lg:block"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className={`flex items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="flex items-center mb-4">
                      <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center mr-4">
                        <span className="text-black font-bold">{step.number}</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                        <span className="text-sm text-yellow-600 font-medium">{step.duration}</span>
                      </div>
                    </div>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
                
                {/* タイムライン上の円 */}
                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-6 h-6 bg-yellow-400 rounded-full border-4 border-white shadow-lg"></div>
                </div>
                
                <div className="hidden lg:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
